import React from 'react';
import './Footer.css'; 
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,  // Scroll to the top of the page
      behavior: 'smooth',  // Smooth scroll
    });
  };
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {currentYear} Live Cricket Score App. All rights reserved.</p>
        <ul className="footer-links" onClick={scrollToTop} >
          <li><Link to="https://www.quickdials.in/" target="_blank">Business Free Listing </Link></li>
          <li><Link to="/about" >About Us</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms-of-service">Terms of Service</Link></li>

        </ul>
      </div>
    </footer>
  );
};

export default Footer;
